import React from "react";
import Features from "../components/features/Features";
import Footer from "../components/layout/footer/Footer";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import AllReview from "../components/testimonial/AllReview";

export default function Review() {
  return (
    <Layout>
      <Navbar />
      <PageHeader HeaderTitle="Our Profile" PageTitle="Our Profile" />
      <section className="promo-section mt-5 ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-10">
            
            <h2 className="mb-6" style={{color:'#145580'}}>
               </h2>
            </div>
          </div>
          <p>The Sustainable Institute has been established as a brilliant response to the increasing
need for innovative technological, social and economic development initiatives. We
believe these initiatives form the backbone to improving quality of life and to
providing opportunities for citizens, organizations, and business. The Sustainable
Institute is an industry-leading management firm esteemed by governments,
companies, and organizations around the world. We specialize in investments,
programs, strategies, and the management of complex assignments. Our services
encompass a variety of critical activities throughout the project cycle from the initial
concept development to its management, and then through its evaluation.</p>
          <p>The Sustainable Institute’s singular goal is to make this process as simple and
seamless as possible while ensuring that we meet our client’s expectations. We
assemble the most qualified project teams, utilize the most advanced tools, and
employ the best technical experts in the marketplace to accomplish this goal.</p>
<p>The keystone of our process lies in our ability to listen to and understand our client’s
needs. We work with our clients to first develop a vision of their project or program
and then to translate it into a comprehensive strategic plan of action. Our firm
establishes and maintains relations with world-class international team members, and
we can assure you that your project is a top priority for all members of the team.</p>
<p>We do our best to keep it green!</p>
        </div>
      </section>
      <Features/>
      <AllReview />
      <Footer />
    </Layout>
  );
}
